import { Grid, Typography } from '@mui/material';
import { PqrTimesDataProps } from './props';
import { usePqrTimesData } from './hook';
import FieldText from '../../../../../components/general/fields/fieldText';
import { Checkbox } from '../../../../../components/general/fields/checkbox';

export const PqrTimesData = ({ data }: PqrTimesDataProps) => {
    const { formik } = usePqrTimesData(data);

    return (
        <Grid
            container
            spacing={{ xs: 1.5, md: 1.5 }}
            columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            pt="20px"
        >
            <Grid item xs={12}>
                <Typography style={{ fontWeight: 'bold', color: '#000' }}>
                    Estados
                </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Estado de la Regla"
                    name="status"
                    size="small"
                    disabled
                    errors={formik.errors.status}
                    value={formik.values.status}
                />
            </Grid>

            <Grid item xs={12}>
                <Typography style={{ fontWeight: 'bold', color: '#000' }}>
                    Proceso
                </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Canal de recepción"
                    name="receptionChannel"
                    size="small"
                    disabled
                    errors={formik.errors.receptionChannel}
                    value={formik.values.receptionChannel}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Tipo PQR"
                    name="type"
                    size="small"
                    disabled
                    errors={formik.errors.type}
                    value={formik.values.type}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Medio"
                    name="half"
                    size="small"
                    disabled
                    errors={formik.errors.half}
                    value={formik.values.half}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Subtipo DP"
                    name="subtypeDp"
                    size="small"
                    disabled
                    errors={formik.errors.subtypeDp}
                    value={formik.values.subtypeDp}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Trámite"
                    name="procedure"
                    size="small"
                    disabled
                    errors={formik.errors.procedure}
                    value={formik.values.procedure}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Fecha base para calculo de días"
                    name="typeDay"
                    size="small"
                    disabled
                    errors={formik.errors.typeDay}
                    value={formik.values.typeDay}
                />
            </Grid>
            <Grid item xs={12} sm={8}>
                <FieldText
                    label="Nombre"
                    name="name"
                    size="small"
                    disabled
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.name}
                    errors={formik.errors.name}
                    value={formik.values.name}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <Checkbox
                    label="Activo"
                    disabled
                    checked={Boolean(formik.values.active)}
                    onChange={() => {
                        formik.setFieldValue('active', !formik.values.active);
                    }}
                />
            </Grid>
            <Grid item xs={12} sm={12}>
                <FieldText
                    label="Observación"
                    name="observation"
                    size="small"
                    disabled
                    onBlur={formik.handleBlur}
                    touched={formik.touched.observation}
                    errors={formik.errors.observation}
                    value={formik.values.observation}
                    onChange={formik.handleChange}
                    rows={3}
                />
            </Grid>
        </Grid>
    );
};
